import BaseAPI from '@/apis/base/baseApi';

class WebsiteWideTaskResultDeviceAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteWideTaskResultDevice';
}

export default new WebsiteWideTaskResultDeviceAPI();
